/**
 * Sets the `.name` property of a class to survive bundler transformations.
 *
 * Bundlers like esbuild transform `class MyClass {}` to `const MyClass = class {}`,
 * which loses the class name. Then, a mangler like terser will mangle `MyClass`,
 * resulting in unhelpful error stacktraces.
 *
 * This utility preserves it by explicitly setting the `name` property using `Object.defineProperty`.
 *
 * @example
 * ```ts
 * class MyError extends Error {}
 * setClassName(MyError, 'MyError');
 * // MyError.name === 'MyError' even after bundling
 * ```
 */
export function setClassName<T extends abstract new (...args: never) => unknown>(cls: T, name: string): T {
	Object.defineProperty(cls, 'name', { value: name, configurable: true });
	return cls;
}
